import { Box, Button, Checkbox, InputBase, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import theme from '../../../themes/theme';
import DialogAddCost from './DialogAddCost';
import { useState } from 'react';
import SimpleSnackbar from '../../ui/SimpleSnackbar';
import { useEffect } from 'react';
import CostFilter from './CostFilter';
import DialogEditCost from './DialogEditCost';

export default function CostObjects(props) {
    const { allCostObject, saveLogbookSetting } = props;
    const { t } = useTranslation();
    const [message, setMessage] = useState('');
    const [costObjects, setCostObjects] = useState([]);
    const [checked, setChecked] = useState([]);
    const [hoveredListItem, setHoveredListItem] = useState('');
    const [filterName, setFilterName] = useState(t('active'));
    const [searchValue, setSearchValue] = useState('');
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        setChecked([]);
    }, [filterName]);

    useEffect(() => {
        if (searchValue.length === 0) {
            setCostObjects(
                allCostObject?.filter((costObject) => {
                    return (filterName === t('active') && costObject.active === true) || (filterName === t('deactivated') && costObject.active === false);
                })
            );
        } else {
            setCostObjects(
                allCostObject
                    ?.filter((costObject) => {
                        return (filterName === t('active') && costObject.active === true) || (filterName === t('deactivated') && costObject.active === false);
                    })
                    ?.filter((costObject) => costObject?.name?.toLowerCase().includes(searchValue.toLowerCase()))
            );
        }
    }, [searchValue, filterName, allCostObject, t]);

    const handleListItemClick = (event, costObjectId) => {
        if (isMobile) {
            checkHoveredLogbook(costObjectId);
        } else {
            handleToggle(event, costObjectId);
        }
    };

    const handleToggle = (event, costObjectId) => {
        event.stopPropagation();
        const currentIndex = checked.indexOf(costObjectId);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(costObjectId);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const handleChangeCheckedAll = () => {
        if (checked.length < getCostObjectsInList()?.length) {
            setChecked(getCostObjectsInList()?.map((costObject) => costObject.id));
        } else {
            setChecked([]);
        }
    };

    const handleChangeStatusAll = (value) => {
        let newCostObjectList = allCostObject.map((costObject) => {
            let newCostObject = null;
            if (!checked.includes(costObject.id)) {
                newCostObject = costObject;
            } else {
                if (value === t('activate')) {
                    newCostObject = {
                        id: costObject.id,
                        name: costObject.name,
                        active: true,
                    };
                } else if (value === t('deactivate')) {
                    newCostObject = {
                        id: costObject.id,
                        name: costObject.name,
                        active: false,
                    };
                }
            }
            return newCostObject;
        });
        setChecked([]);
        checkHoveredLogbook('');
        saveLogbookSetting('costObject', newCostObjectList);
    };

    const checkHoveredLogbook = (id) => {
        if (hoveredListItem !== id) {
            setHoveredListItem(id);
        } else {
            setHoveredListItem('');
        }
    };

    const changeActiveStatus = (event, id, value) => {
        event.stopPropagation();
        let newCostObjectList = allCostObject.map((costObject) => {
            let newCostObject = null;
            if (id !== costObject.id) {
                newCostObject = costObject;
            } else {
                if (value === t('activate')) {
                    newCostObject = {
                        id: costObject.id,
                        name: costObject.name,
                        active: true,
                    };
                } else if (value === t('deactivate')) {
                    newCostObject = {
                        id: costObject.id,
                        name: costObject.name,
                        active: false,
                    };
                }
            }
            return newCostObject;
        });
        setChecked([]);
        saveLogbookSetting('costObject', newCostObjectList);
        if (isMobile) {
            checkHoveredLogbook('');
        }
    };

    const addCost = (costObject) => {
        const newCostObjectList = [...allCostObject];
        newCostObjectList.push(costObject);
        saveLogbookSetting('costObject', newCostObjectList);
    };

    const editCost = (costObject) => {
        const newCostObjectList = [...allCostObject];
        const index = newCostObjectList.findIndex((cC) => cC.id === costObject.id);
        newCostObjectList[index] = costObject;
        saveLogbookSetting('costObject', newCostObjectList);
    };

    const getCostObjectsInList = () => {
        const costObjectInList = allCostObject?.filter((costObject) => {
            return (filterName === t('active') && costObject.active === true) || (filterName === t('deactivated') && costObject.active === false);
        });
        return costObjectInList;
    };

    const getWidth = () => {
        const widthList = document?.getElementById('costObjectList')?.offsetWidth;
        return widthList === undefined ? '0px' : `${widthList}px`;
    };

    return (
        <>
            <CostFilter filterName={filterName} setFilterName={setFilterName} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '16px' }}>
                <Box display='flex' alignItems='center' padding='0 8px' borderRadius='24px' marginBottom='8px' maxWidth='264px' height='40px' bgcolor={theme.palette.grey[100]}>
                    <InputBase placeholder={t('searchInList')} value={searchValue} onChange={(event) => setSearchValue(event.target.value)} />
                </Box>
                <DialogAddCost addCost={addCost} title={t('addCostObject')} label={t('costObject')} />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <ListItem key='all' disablePadding sx={{ height: '48px' }}>
                    <ListItemIcon sx={{ marginRight: '-16px' }}>
                        <Checkbox
                            edge='end'
                            checked={checked.length === getCostObjectsInList()?.length}
                            indeterminate={checked.length > 0 && checked.length < getCostObjectsInList()?.length}
                            onClick={() => handleChangeCheckedAll()}
                        />
                    </ListItemIcon>
                    <ListItemText
                        id='all'
                        primary={`${t('all')} (${checked.length} ${t('of')} ${getCostObjectsInList()?.length})`}
                        sx={{ textAlign: 'left', paddingRight: '16px' }}
                    />
                    {checked.length > 0 && (
                        <Button
                            variant='outlined'
                            sx={{
                                marginLeft: '8px',
                                color: filterName === t('active') ? '#FF3D00' : '#16A100',
                                '&:hover': { borderColor: filterName === t('active') ? '#FF3D00' : '#16A100' },
                            }}
                            onClick={() => handleChangeStatusAll(filterName === t('active') ? t('deactivate') : t('activate'))}
                        >
                            {filterName === t('active') ? t('deactivate') : t('activate')}
                        </Button>
                    )}
                </ListItem>
            </Box>
            <List dense sx={{ height: 'calc(100vh - 474px)', overflowY: 'auto' }} id='costObjectList'>
                {costObjects?.length > 0 &&
                    costObjects?.map((data) => {
                        return (
                            <ListItem
                                key={data.id}
                                disablePadding
                                sx={{
                                    height: '48px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: theme.palette.grey[100],
                                    },
                                }}
                                onClick={(event) => handleListItemClick(event, data.id)}
                                onMouseEnter={() => checkHoveredLogbook(data.id)}
                                onMouseLeave={() => checkHoveredLogbook('')}
                            >
                                <ListItemIcon sx={{ marginRight: '-16px' }} onClick={(event) => handleToggle(event, data.id)}>
                                    <Checkbox edge='end' checked={checked.indexOf(data.id) !== -1} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={data.name}
                                    primaryTypographyProps={{
                                        width: isMobile
                                            ? hoveredListItem === data.id
                                                ? `calc(${getWidth()} - 220px)`
                                                : `calc(${getWidth()} - 40px)`
                                            : hoveredListItem === data.id
                                            ? `calc(${getWidth()} - 240px)`
                                            : `calc(${getWidth()} - 40px)`,
                                        position: 'relative',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                    }}
                                />
                                {hoveredListItem === data.id && (
                                    <>
                                        <DialogEditCost
                                            editCost={editCost}
                                            currentCost={data}
                                            title={t('editCostObject')}
                                            label={t('costObject')}
                                            checkHoveredLogbook={checkHoveredLogbook}
                                        />
                                        <Button
                                            variant='outlined'
                                            sx={{
                                                marginLeft: '8px',
                                                color: filterName === t('active') ? '#FF3D00' : '#16A100',
                                                '&:hover': { borderColor: filterName === t('active') ? '#FF3D00' : '#16A100' },
                                            }}
                                            onClick={(event) => changeActiveStatus(event, data.id, data?.active ? t('deactivate') : t('activate'))}
                                        >
                                            {data?.active ? t('deactivate') : t('activate')}
                                        </Button>
                                    </>
                                )}
                            </ListItem>
                        );
                    })}
                {costObjects?.length === 0 && (
                    <ListItem>
                        <ListItemText>
                            <Typography variant='caption' color='gray'>
                                {t('noResult')}
                            </Typography>
                        </ListItemText>
                    </ListItem>
                )}
            </List>
            {message && <SimpleSnackbar message={message} setMessage={setMessage} />}
        </>
    );
}
